//sadnand_gadwal

// Presales Incentive Plan
export const GET_PRESALES_INCENTIVE_PLAN = "GET_PRESALES_INCENTIVE_PLAN";
export const GET_PRESALES_INCENTIVE_PLAN_EXPORT =
  "GET_PRESALES_INCENTIVE_PLAN_EXPORT";
export const GET_PRESALES_INCENTIVE_PLAN_DETAIL =
  "GET_PRESALES_INCENTIVE_PLAN_DETAIL";
export const GET_ITEM_FOR_PRE_SALES_INCENTIVE =
  "GET_ITEM_FOR_PRE_SALES_INCENTIVE";

// PreSales New
//index
export const GET_LEAD = "GET_LEAD";
export const GET_LEAD_EXPORT = "GET_LEAD_EXPORT";
export const GET_LEAD_SEARCH = "GET_LEAD_SEARCH";
export const GET_CRM_LEAD_STATUS_COUNT = "GET_CRM_LEAD_STATUS_COUNT";
export const GET_LEAD_FOR_BULK = "GET_LEAD_FOR_BULK";
export const GET_PROJECT_SHAREABLE_INFO = "GET_PROJECT_SHAREABLE_INFO";
//addmodal
export const GET_USER_FOR_LEAD = "GET_USER_FOR_LEAD";
export const GET_USER_FOR_SITE_VISIT_HANDLED =
  "GET_USER_FOR_SITE_VISIT_HANDLED";
export const GET_COUNTRY_CODE_FOR_PRESALES = "GET_COUNTRY_CODE_FOR_PRESALES"; //completed
export const GET_PROJECT_FOR_LEAD = "GET_PROJECT_FOR_LEAD"; //completed
export const GET_SOURCE_CATEGORY_FOR_PRESALES =
  "GET_SOURCE_CATEGORY_FOR_PRESALES";
export const GET_SOURCE_FOR_LEAD = "GET_SOURCE_FOR_LEAD"; //completed
export const GET_SUB_SOURCE_FOR_LEAD = "GET_SUB_SOURCE_FOR_LEAD"; //completed
export const GET_LEAD_CATEGORY_FOR_PRESALES = "GET_LEAD_CATEGORY_FOR_PRESALES"; //completed
export const GET_LEAD_DETAIL = "GET_LEAD_DETAIL";

//filter
export const GET_LEAD_FILTER_PROJECT = "GET_LEAD_FILTER_PROJECT";
export const GET_LEAD_FILTER_SOURCE = "GET_LEAD_FILTER_SOURCE";
export const GET_LEAD_FILTER_STATUS = "GET_LEAD_FILTER_STATUS";
export const GET_LEAD_FILTER_CATEGORY = "GET_LEAD_FILTER_CATEGORY";
export const GET_LEAD_FILTER_ASSIGNED_TO = "GET_LEAD_FILTER_ASSIGNED_TO";
export const GET_LEAD_FILTER_DATE_TYPE = "GET_LEAD_FILTER_DATE_TYPE";
export const GET_LEAD_OWNER_FILTER_LIST = "GET_LEAD_OWNER_FILTER_LIST";

//reviewpage
export const GET_LEAD_SITE_VISIT = "GET_LEAD_SITE_VISIT";
export const GET_LEAD_PROFILE = "GET_LEAD_PROFILE";

export const GET_CITY = "GET_CITY";
export const GET_EMPLOYMENT_TYPE = "GET_EMPLOYMENT_TYPE";
//today
export const GET_CUSTOMER_CURRENT_LIVING_FOR_PRESALES =
  "GET_CUSTOMER_CURRENT_LIVING_FOR_PRESALES";
export const GET_CUSTOMER_SUITABLE_TIME_FOR_PRESALES =
  "GET_CUSTOMER_SUITABLE_TIME_FOR_PRESALES";
export const GET_CUSTOMER_CONSTRUCTION_PLANNING_FOR_PRESALES =
  "GET_CUSTOMER_CONSTRUCTION_PLANNING_FOR_PRESALES";
export const GET_CUSTOMER_BUDGET_FOR_PRESALES =
  "GET_CUSTOMER_BUDGET_FOR_PRESALES";
export const GET_CRM_DIMENSION_FOR_PRESALES = "GET_CRM_DIMENSION_FOR_PRESALES";
export const GET_CUSTOMER_INCOME_FOR_PRESALES =
  "GET_CUSTOMER_INCOME_FOR_PRESALES";
export const GET_CUSTOMER_WORK_EXPERIENCE_FOR_PRESALES =
  "GET_CUSTOMER_WORK_EXPERIENCE_FOR_PRESALES";
export const GET_CUSTOMER_WORK_FUNCTION_FOR_PRESALES =
  "GET_CUSTOMER_WORK_FUNCTION_FOR_PRESALES";
export const GET_CUSTOMER_WORK_SECTOR_FOR_PRESALES =
  "GET_CUSTOMER_WORK_SECTOR_FOR_PRESALES";
export const GET_CUSTOMER_ORGANIZATION_FOR_PRESALES =
  "GET_CUSTOMER_ORGANIZATION_FOR_PRESALES";
export const GET_CUSTOMER_PURCHASE_REASON_FOR_PRESALES =
  "GET_CUSTOMER_PURCHASE_REASON_FOR_PRESALES";
export const CHECK_EXISTING_LEAD = "CHECK_EXISTING_LEAD";
export const GET_USER_FOR_LEAD_SITE_VISIT = "GET_USER_FOR_LEAD_SITE_VISIT";
export const GET_SITE_VISIT_VECHICLE_MODE = "GET_SITE_VISIT_VECHICLE_MODE";
export const GET_LEAD_CALL_STATUS_FOR_FOLLOW_UP =
  "GET_LEAD_CALL_STATUS_FOR_FOLLOW_UP";
export const GET_LEAD_STATUS_FOR_FOLLOW_UP = "GET_LEAD_STATUS_FOR_FOLLOW_UP";
export const GET_LEAD_UNQULIFICATION_REASON_FOR_FOLLOW_UP =
  "GET_LEAD_UNQULIFICATION_REASON_FOR_FOLLOW_UP";
export const GET_LEAD_BUDGET_FOR_FOLLOW_UP = "GET_LEAD_BUDGET_FOR_FOLLOW_UP";
export const GET_LEAD_LOCATION_FOR_FOLLOW_UP =
  "GET_LEAD_LOCATION_FOR_FOLLOW_UP";
export const GET_LEAD_LOCATION_FOR_FOLLOW_UP_AUTO =
  "GET_LEAD_LOCATION_FOR_FOLLOW_UP_AUTO";
export const MAKE_EXOTEL_OUTGOING_CALL = "MAKE_EXOTEL_OUTGOING_CALL";

//lead site visit plan
export const GET_SITE_VISIT_PLAN = "GET_SITE_VISIT_PLAN";
export const GET_SITE_VISIT_PLAN_EXPORT = "GET_SITE_VISIT_PLAN_EXPORT";
export const GET_SITE_VISIT_PLAN_DETAIL = "GET_SITE_VISIT_PLAN_DETAIL";
export const GET_SITE_VISIT_PLAN_FILTER_PROJECT =
  "GET_SITE_VISIT_PLAN_FILTER_PROJECT";
export const GET_SITE_VISIT_PLAN_FILTER_STM = "GET_SITE_VISIT_PLAN_FILTER_STM";
export const GET_ASSIGN_TO_USER_FOR_SITE_VISIT =
  "GET_ASSIGN_TO_USER_FOR_SITE_VISIT";
export const GET_IMPORT_LEAD = "GET_IMPORT_LEAD";
export const GET_IMPORT_LEAD_FILTER_UPLOADED_BY =
  "GET_IMPORT_LEAD_FILTER_UPLOADED_BY";

export const GET_PROJECT_INFO = "GET_PROJECT_INFO";
export const GET_PROJECT_INFO_EXPORT = "GET_PROJECT_INFO_EXPORT";
export const GET_PROJECT_INFO_DETAIL = "GET_PROJECT_INFO_DETAIL";
export const GET_CRM_SALES_DOCUMENT_TYPE = "GET_CRM_SALES_DOCUMENT_TYPE";

// externalLead
export const GET_EXTERNAL_LEAD = "GET_EXTERNAL_LEAD";
export const GET_EXTERNAL_LEAD_EXPORT = "GET_EXTERNAL_LEAD_EXPORT";
export const GET_EXTERNAL_LEAD_FILTER_PROJECT =
  "GET_EXTERNAL_LEAD_FILTER_PROJECT";
export const GET_EXTERNAL_LEAD_FILTER_SOURCE =
  "GET_EXTERNAL_LEAD_FILTER_SOURCE";
export const GET_EXTERNAL_LEAD_FILTER_SUB_SOURCE =
  "GET_EXTERNAL_LEAD_FILTER_SUB_SOURCE";
export const GET_EXTERNAL_LEAD_FILTER_ASSIGNED_TO =
  "GET_EXTERNAL_LEAD_FILTER_ASSIGNED_TO";
export const GET_EXTERNAL_LEAD_FILTER_LEAD_STATUS =
  "GET_EXTERNAL_LEAD_FILTER_LEAD_STATUS";
